"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _numberFormatter = require("../../helpers/numberFormatter");
var level1DataProp = _interopRequireWildcard(require("../../propTypes/level1Data"));
var _TickerBase = _interopRequireDefault(require("./components/TickerBase"));
require("./TickerComponent.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var TickerComponent = /*#__PURE__*/function (_React$Component) {
  function TickerComponent() {
    _classCallCheck(this, TickerComponent);
    return _callSuper(this, TickerComponent, arguments);
  }
  _inherits(TickerComponent, _React$Component);
  return _createClass(TickerComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        level1 = _this$props.level1,
        instruments = _this$props.instruments,
        icons = _this$props.icons,
        direction = _this$props.direction,
        speed = _this$props.speed;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "ticker-marquee"
      }, /*#__PURE__*/_react["default"].createElement(_TickerBase["default"], {
        direction: direction,
        speed: speed,
        autoFill: true
      }, instruments.map(function (instrument) {
        var _icons$instrymentSymb;
        var level1Data = level1[instrument.InstrumentId] || {};
        var lastTrade = level1Data['LastTradedPx'];
        var colorClass = level1Data['Rolling24HrPxChange'] < 0 ? 'trade_down' : 'trade_up';
        var instrymentSymbol = instrument.Product1Symbol;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "ticker-block",
          key: instrument.InstrumentId,
          style: lastTrade <= 0 ? {
            display: 'none'
          } : {}
        }, /*#__PURE__*/_react["default"].createElement("p", {
          className: "ticker-symbol"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "ticker-symbol__icon"
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: "/local/product-icons/".concat((_icons$instrymentSymb = icons[instrymentSymbol]) === null || _icons$instrymentSymb === void 0 ? void 0 : _icons$instrymentSymb.iconFileName),
          alt: ""
        })), instrument.Symbol), /*#__PURE__*/_react["default"].createElement("p", {
          className: "ticker-last-trade"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: colorClass
        }, (0, _numberFormatter.formatNumberToLocale)(lastTrade, instrument.Symbol)), /*#__PURE__*/_react["default"].createElement("span", {
          className: "currency"
        }, instrument.Product2Symbol)));
      })));
    }
  }]);
}(_react["default"].Component);
TickerComponent.propTypes = {
  instruments: _propTypes["default"].array.isRequired,
  show24HrPxChange: _propTypes["default"].bool,
  show24HrVolume: _propTypes["default"].bool,
  direction: _propTypes["default"].string
};
TickerComponent.defaultProps = {
  level1: level1DataProp.defaultProps
};
var _default = exports["default"] = TickerComponent;